// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"143":"dab9e200","189":"23915234","469":"37994193","524":"ffa816c0","626":"0b1ebab8"}[chunkId] + ".chunk.js";
};